var $9867160d996455a0$exports = {};
$9867160d996455a0$exports = {
    "close": `Aizv\u{113}rt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pazi\u{146}ojums`,
            other: ()=>`${formatter.number(args.count)} pazi\u{146}ojumi`
        })}.`
};


export {$9867160d996455a0$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
